import { render, staticRenderFns } from "./hourglass.vue?vue&type=template&id=563d8e03"
import script from "./hourglass.vue?vue&type=script&lang=js"
export * from "./hourglass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports